import React from "react";
import { Link } from "react-router-dom";

/**
 * ZenMe Group glyph + wordmark.
 * Glyph: stylized "Z" as two stacked diagonal lines with a small accent dot.
 * Geometric, sharp, enterprise-inspired.
 */
export const LogoGlyph = ({ size = 22, className = "" }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            className={className}
            aria-hidden
        >
            {/* Top diagonal stroke */}
            <path
                d="M4 5 H19 L8 11"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="square"
                strokeLinejoin="miter"
            />
            {/* Bottom diagonal stroke */}
            <path
                d="M5 13 L16 13 L4 19 H19"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="square"
                strokeLinejoin="miter"
            />
            {/* Accent dot */}
            <circle cx="20.5" cy="4.5" r="1.6" fill="#7CFF4F" />
        </svg>
    );
};

export const Logo = ({ className = "", size = "md", asLink = true }) => {
    const sizes = {
        sm: { glyph: 18, text: "text-[14px]" },
        md: { glyph: 22, text: "text-[15px]" },
        lg: { glyph: 28, text: "text-[18px]" },
    };
    const s = sizes[size] || sizes.md;

    const inner = (
        <span
            className={`inline-flex items-center gap-2.5 text-text-primary ${className}`}
        >
            <LogoGlyph size={s.glyph} className="text-text-primary" />
            <span
                className={`font-display font-semibold tracking-tight-2 ${s.text}`}
                style={{ letterSpacing: "0.04em" }}
            >
                ZENME&nbsp;GROUP
            </span>
        </span>
    );

    if (!asLink) return inner;
    return (
        <Link
            to="/"
            className="inline-flex items-center hover:opacity-90 transition-opacity"
            data-testid="logo-home-link"
        >
            {inner}
        </Link>
    );
};

export default Logo;
